<template>
  <div>
    <div>{{ formatDate(val, 'DD.MM.YYYY') }}</div>
    <div class="text-muted">{{ formatDate(val, 'HH:mm') }}</div>
  </div>
</template>

<script setup>
import {computed} from "vue"
import {formatDate} from "@/extensions/filters/filters"

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  },
})

const val = computed(() => props.object?.[props.field?.id] || null)
</script>
